import { queryOptions, useMutation, useQuery } from "@tanstack/react-query";
import { message } from "antd";
import { apiBase } from "../utils/apiBase";
import { queryClient, REFERENCE_QUERY_OPTIONS } from "./queryClient";

export const appConfigQuery = queryOptions({
  queryKey: ["appConfig"],
  queryFn: () => apiBase.get("app-config").then((res) => res.data),
  ...REFERENCE_QUERY_OPTIONS,
  meta: { errorMessage: "Failed to load app config." },
});

export const useAppConfig = () => useQuery(appConfigQuery);

// PATCH returns the fresh config, so write it straight into the cache — this is
// the invalidation for the long-lived ["appConfig"] query.
export const useUpdateAppConfig = () =>
  useMutation({
    mutationFn: (values) =>
      apiBase.patch("app-config", values).then((res) => res.data),
    onSuccess: (data) => {
      queryClient.setQueryData(appConfigQuery.queryKey, data);
      message.success("Successfully updated settings.");
    },
    onError: () => {
      message.error("Failed to update app config.");
    },
  });
